// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { register } from "../../redux/actions/authActions";
// import { fetchRelationships } from "../../redux/actions/relationshipActions";
// import { fetchUsers } from "../../redux/actions/authActions";
// import {
//   Container,
//   TextField,
//   Button,
//   Typography,
//   Box,
//   Paper,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   IconButton,
//   InputAdornment,
//   Autocomplete,
//   Grid,
// } from "@mui/material";
// import { useSnackbar } from "notistack";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import PersonIcon from "@mui/icons-material/Person";
// import EmailIcon from "@mui/icons-material/Email";
// import LockIcon from "@mui/icons-material/Lock";
// import WorkIcon from "@mui/icons-material/Work";
// import GroupIcon from "@mui/icons-material/Group";
// import { actionButtonStyles } from "../../styles/actionButton";
// import { windowsTableStyles } from "../../styles/windowsTableStyles";
// import { textFieldStyles } from "../../styles/textFieldStyles";
// import BreadcrumbNav from "../../components/BreadcrumbNav";
// import { CustomPaper } from "../../styles/customPaper";
// import { AddBox } from "@mui/icons-material";
// import { mediumTitle, smallTitle } from "../../styles/typography";

// const Signup = () => {
//   const [formData, setFormData] = useState({
//     firstName: "",
//     middleName: "",
//     lastName: "",
//     email: "",
//     password: "",
//     role: "",
//     relationship: "",
//     keepLoggedIn: false,
//     avatar: "",
//   });

//   const [showPassword, setShowPassword] = useState(false);

//   const {
//     firstName,
//     middleName,
//     lastName,
//     email,
//     password,
//     role,
//     relationship,
//     keepLoggedIn,
//     avatar,
//   } = formData;

//   const dispatch = useDispatch();
//   const { enqueueSnackbar } = useSnackbar();
//   const { isAuthenticated, error } = useSelector((state) => state.userLoaded);
//   const { relationships } = useSelector((state) => state.relationshipList);
//   const { users } = useSelector((state) => state.userList);

//   const [notificationShown, setNotificationShown] = useState(true);

//   const generateAvatar = (firstName, lastName) => {
//     const colors = [
//       "#FAD7A0",
//       "#AED6F1",
//       "#ABEBC6",
//       "#F5B7B1",
//       "#F9E79F",
//       "#D7BDE2",
//     ];
//     const bgColor = colors[Math.floor(Math.random() * colors.length)];
//     const initials = `${firstName[0]}${lastName[0]}`;
//     const avatarURL = `https://ui-avatars.com/api/?name=${initials}&background=${bgColor.replace(
//       "#",
//       ""
//     )}&color=000&size=128`;
//     return avatarURL;
//   };

//   useEffect(() => {
//     dispatch(fetchRelationships());
//     dispatch(fetchUsers());
//   }, [dispatch]);

//   const onChange = (e) =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });

//   const onSubmit = (e) => {
//     e.preventDefault();
//     console.log(firstName, " l ", lastName);
//     const avatar = generateAvatar(firstName, lastName);
//     console.log(avatar);
//     dispatch(
//       register({
//         firstName,
//         middleName,
//         lastName,
//         email,
//         password,
//         role,
//         relationship,
//         keepLoggedIn,
//         avatar,
//       })
//     );
//     setNotificationShown(false); // Reset notification state on form submission
//   };

//   useEffect(() => {
//     if (isAuthenticated && !notificationShown) {
//       enqueueSnackbar("User created successfully!", { variant: "success" });
//       setNotificationShown(true); // Set notification state to true after showing
//     }
//     if (error && !notificationShown) {
//       enqueueSnackbar(error, { variant: "error" });
//       setNotificationShown(true); // Set notification state to true after showing
//     }
//   }, [isAuthenticated, error, enqueueSnackbar, notificationShown]);

//   const handleRelationshipChange = (event, newValue) => {
//     if (newValue) {
//       setFormData({
//         ...formData,
//         firstName: newValue.firstName,
//         middleName: newValue.middleName || "",
//         lastName: newValue.lastName,
//         email: newValue.email,
//         relationship: newValue._id,
//       });
//     } else {
//       setFormData({
//         ...formData,
//         firstName: "",
//         middleName: "",
//         lastName: "",
//         email: "",
//         relationship: "",
//       });
//     }
//   };

//   // Filter out relationships that are already assigned to a user
//   const availableRelationships = relationships.filter(
//     (rel) => !users.some((user) => user.relationship === rel._id)
//   );

//   // Define the options for the Autocomplete component
//   const roleOptions = [
//     { label: "Assistant Lawyer", value: "Assistant Lawyer" },
//     { label: "Responsible Lawyer", value: "Responsible Lawyer" },
//     // { label: 'Manager', value: 'Manager' },
//   ];

//   return (
//     <Container component="main" maxWidth="lg">
//       <Paper elevation={3} sx={{ padding: 4, marginTop: 4 }}>
//         <Box component="h1" variant="h5" align="left" sx={mediumTitle}>
//           Create an account
//         </Box>
//         <form onSubmit={onSubmit}>
//           <Grid container spacing={2}>
//             <Grid item xs={4}>
//               <Autocomplete
//                 options={availableRelationships.filter(
//                   (rel) => rel.type === "Lawyer"
//                 )}
//                 getOptionLabel={(option) =>
//                   `${option.uniqueNumber} - ${option.firstName} ${
//                     option.middleName ? `${option.middleName} ` : ""
//                   }${option.lastName}`
//                 }
//                 value={
//                   availableRelationships.find(
//                     (rel) => rel._id === relationship
//                   ) || null
//                 }
//                 onChange={handleRelationshipChange}
//                 PaperComponent={CustomPaper}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label="Relationship"
//                     size="small"
//                     sx={{
//                       ...textFieldStyles({ marginRight: "0" }),
//                     }}
//                     margin="normal"
//                     required
//                     fullWidth
//                     InputProps={{
//                       ...params.InputProps,
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <GroupIcon />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 )}
//               />
//             </Grid>
//             <Grid container spacing={2} item xs={12}>
//               <Grid item xs={4}>
//                 <TextField
//                   margin="normal"
//                   id="firstName"
//                   label="First Name"
//                   name="firstName"
//                   autoComplete="given-name"
//                   autoFocus
//                   value={firstName}
//                   fullWidth
//                   onChange={onChange}
//                   size="small"
//                   sx={{
//                     ...textFieldStyles({ marginRight: "0" }),
//                   }}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <PersonIcon />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={4}>
//                 <TextField
//                   size="small"
//                   sx={{
//                     ...textFieldStyles({ marginRight: "0" }),
//                   }}
//                   fullWidth
//                   id="middleName"
//                   label="Middle Name"
//                   name="middleName"
//                   autoComplete="additional-name"
//                   value={middleName}
//                   onChange={onChange}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <PersonIcon />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={4}>
//                 <TextField
//                   required
//                   fullWidth
//                   size="small"
//                   sx={{
//                     ...textFieldStyles({ marginRight: "0" }),
//                   }}
//                   id="lastName"
//                   label="Last Name"
//                   name="lastName"
//                   autoComplete="family-name"
//                   value={lastName}
//                   onChange={onChange}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <PersonIcon />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>
//             </Grid>

//             <Grid item xs={4}>
//               <TextField
//                 required
//                 id="email"
//                 label="Email Address"
//                 name="email"
//                 autoComplete="email"
//                 value={email}
//                 onChange={onChange}
//                 fullWidth
//                 size="small"
//                 sx={{
//                   ...textFieldStyles({ marginRight: "0" }),
//                 }}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <EmailIcon />
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={4}>
//               <TextField
//                 required
//                 fullWidth
//                 name="password"
//                 label="Password"
//                 type={showPassword ? "text" : "password"}
//                 id="password"
//                 autoComplete="current-password"
//                 value={password}
//                 onChange={onChange}
//                 size="small"
//                 sx={{
//                   ...textFieldStyles({ marginRight: "0" }),
//                 }}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <LockIcon />
//                     </InputAdornment>
//                   ),
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton
//                         aria-label="toggle password visibility"
//                         onClick={() => setShowPassword(!showPassword)}
//                         edge="end"
//                       >
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={4}>
//               <FormControl fullWidth >
//                 <Autocomplete
//                   options={roleOptions}
//                   getOptionLabel={(option) => option.label}
//                   value={
//                     roleOptions.find((option) => option.value === role) || null
//                   }
//                   onChange={(event, newValue) =>
//                     onChange({
//                       target: {
//                         name: "role",
//                         value: newValue ? newValue.value : "",
//                       },
//                     })
//                   }
//                   PaperComponent={CustomPaper}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label="Role"
//                       size="small"
//                     sx={{
//                       ...textFieldStyles({ marginRight: "0" }),
//                     }}
//                       InputProps={{
//                         ...params.InputProps,
//                         startAdornment: (
//                           <>
//                             <InputAdornment position="start">
//                               <WorkIcon />
//                             </InputAdornment>
//                             {params.InputProps.startAdornment}
//                           </>
//                         ),
//                       }}
//                     />
//                   )}
//                 />
//               </FormControl>
//             </Grid>
//           </Grid>
//           <Box sx={{marginTop: 4}}>
//           <Button
//             type="submit"
//             fullWidth
//             sx={actionButtonStyles}
//           >
//             Create Account
//           </Button>
//           </Box>
          
//         </form>
//       </Paper>
//     </Container>
//   );
// };

// export default Signup;



import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { register } from "../../redux/actions/authActions";
import { fetchRelationships } from "../../redux/actions/relationshipActions";
import { fetchUsers } from "../../redux/actions/authActions";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  InputAdornment,
  Autocomplete,
  Grid,
} from "@mui/material";
import { useSnackbar } from "notistack";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import WorkIcon from "@mui/icons-material/Work";
import GroupIcon from "@mui/icons-material/Group";
import { actionButtonStyles } from "../../styles/actionButton";
import { windowsTableStyles } from "../../styles/windowsTableStyles";
import { textFieldStyles } from "../../styles/textFieldStyles";
import BreadcrumbNav from "../../components/BreadcrumbNav";
import { CustomPaper } from "../../styles/customPaper";
import { AddBox } from "@mui/icons-material";
import { mediumTitle, smallTitle } from "../../styles/typography";
import { useTranslation } from 'react-i18next';

const Signup = () => {
  const { t } = useTranslation(['forms', 'buttons', 'messages']);
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    password: "",
    role: "",
    relationship: "",
    keepLoggedIn: false,
    avatar: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const {
    firstName,
    middleName,
    lastName,
    email,
    password,
    role,
    relationship,
    keepLoggedIn,
    avatar,
  } = formData;

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { isAuthenticated, error } = useSelector((state) => state.userLoaded);
  const { relationships } = useSelector((state) => state.relationshipList);
  const { users } = useSelector((state) => state.userList);

  const [notificationShown, setNotificationShown] = useState(true);


  useEffect(() => {
    dispatch(fetchRelationships());
    dispatch(fetchUsers());
  }, [dispatch]);

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    console.log(firstName, " l ", lastName);
    const relation = availableRelationships.find(
      (rel) => rel._id === relationship
    );
    const avatar = relation?.avatar;
    
    dispatch(
      register({
        firstName,
        middleName,
        lastName,
        email,
        password,
        role,
        relationship,
        keepLoggedIn,
        avatar,
      })
    );
    setNotificationShown(false); // Reset notification state on form submission
  };

  useEffect(() => {
    if (isAuthenticated && !notificationShown) {
      enqueueSnackbar("User created successfully!", { variant: "success" });
      setNotificationShown(true); // Set notification state to true after showing
    }
    if (error && !notificationShown) {
      enqueueSnackbar(error, { variant: "error" });
      setNotificationShown(true); // Set notification state to true after showing
    }
  }, [isAuthenticated, error, enqueueSnackbar, notificationShown]);

  const handleRelationshipChange = (event, newValue) => {
    if (newValue) {
      setFormData({
        ...formData,
        firstName: newValue.firstName,
        middleName: newValue.middleName || "",
        lastName: newValue.lastName,
        email: newValue.email,
        relationship: newValue._id,
      });
    } else {
      setFormData({
        ...formData,
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        relationship: "",
      });
    }
  };

  // Filter out relationships that are already assigned to a user
  const availableRelationships = relationships.filter(
    (rel) => !users.some((user) => user.relationship === rel._id)
  );

  // Define the options for the Autocomplete component
  const roleOptions = [
    { label: "Assistant Lawyer", value: "Assistant Lawyer" },
    { label: "Responsible Lawyer", value: "Responsible Lawyer" },
    // { label: 'Manager', value: 'Manager' },
  ];

  return (
    <Container component="main" maxWidth="lg">
      <Paper elevation={3} sx={{ padding: 4, marginTop: 4 }}>
        <Box component="h1" variant="h5" align="left" sx={mediumTitle}>
          {t('forms:labels.createAccount')}
        </Box>
        <form onSubmit={onSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Autocomplete
                options={availableRelationships.filter(
                  (rel) => rel.type === "Lawyer"
                )}
                getOptionLabel={(option) =>
                  `${option.uniqueNumber} - ${option.firstName} ${
                    option.middleName ? `${option.middleName} ` : ""
                  }${option.lastName}`
                }
                value={
                  availableRelationships.find(
                    (rel) => rel._id === relationship
                  ) || null
                }
                onChange={handleRelationshipChange}
                PaperComponent={CustomPaper}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Relationship"
                    size="small"
                    sx={{
                      ...textFieldStyles({ marginRight: "0" }),
                    }}
                    margin="normal"
                    required
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <GroupIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid container spacing={2} item xs={12}>
              <Grid item xs={4}>
                <TextField
                  margin="normal"
                  id="firstName"
                  label={t('forms:labels.firstName')}
                  name="firstName"
                  autoComplete="given-name"
                  autoFocus
                  value={firstName}
                  fullWidth
                  onChange={onChange}
                  size="small"
                  sx={{
                    ...textFieldStyles({ marginRight: "0" }),
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  size="small"
                  sx={{
                    ...textFieldStyles({ marginRight: "0" }),
                  }}
                  fullWidth
                  id="middleName"
                  label={t('forms:labels.middleName')}
                  name="middleName"
                  autoComplete="additional-name"
                  value={middleName}
                  onChange={onChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  required
                  fullWidth
                  size="small"
                  sx={{
                    ...textFieldStyles({ marginRight: "0" }),
                  }}
                  id="lastName"
                  label={t('forms:labels.lastName')}
                  name="lastName"
                  autoComplete="family-name"
                  value={lastName}
                  onChange={onChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>

            <Grid item xs={4}>
              <TextField
                required
                id="email"
                label={t('forms:labels.emailAddress')}
                name="email"
                autoComplete="email"
                value={email}
                onChange={onChange}
                fullWidth
                size="small"
                sx={{
                  ...textFieldStyles({ marginRight: "0" }),
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                required
                fullWidth
                name="password"
                label={t('forms:labels.password')}
                type={showPassword ? "text" : "password"}
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={onChange}
                size="small"
                sx={{
                  ...textFieldStyles({ marginRight: "0" }),
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth >
                <Autocomplete
                  options={roleOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    roleOptions.find((option) => option.value === role) || null
                  }
                  onChange={(event, newValue) =>
                    onChange({
                      target: {
                        name: "role",
                        value: newValue ? newValue.value : "",
                      },
                    })
                  }
                  PaperComponent={CustomPaper}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Role"
                      size="small"
                    sx={{
                      ...textFieldStyles({ marginRight: "0" }),
                    }}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <InputAdornment position="start">
                              <WorkIcon />
                            </InputAdornment>
                            {params.InputProps.startAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Box sx={{marginTop: 4}}>
          <Button
            type="submit"
            fullWidth
            sx={actionButtonStyles}
          >
            {t('buttons:primary.createAccount')}
          </Button>
          </Box>
          
        </form>
      </Paper>
    </Container>
  );
};

export default Signup;